import './route_tabs.css';

export const RouteTabs = {
    props: {
        is_active: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        count_length: {
            type: String,
            required: true,
        },
    },
    components: {
    },
    data(): object
    {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
    template: `<div
        class="days-list__day days-list__appointed-day"
        :class="{'days-list_selected': is_active}"
    >
        <div class="days-list__date">{{title}}</div>
        <div class="days-list__counter">{{count_length}}</div>
    </div>`,
}